import { render, staticRenderFns } from "./invadobay-property-card.vue?vue&type=template&id=2bb7ad35&scoped=true"
import script from "./invadobay-property-card.vue?vue&type=script&lang=js"
export * from "./invadobay-property-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7ad35",
  null
  
)

export default component.exports